import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@metarouter-private/mr-mui';
import DeliveryLogsFilters from './DeliveryLogsFilters';
import DeliveryLogsTable from './DeliveryLogsTable';
import useDeliveryLogsTable from './useDeliveryLogsTable';

export default function DeliveryLogsTab({ webhookConfigId }) {
  const { filters, onFilterChange, onFetchPage, data, pagination, loading } = useDeliveryLogsTable({
    webhookConfigId,
  });

  const filterKey = `${filters.eventType ?? 'all'}-${filters.status}`;

  return (
    <Stack spacing={2}>
      <DeliveryLogsFilters filters={filters} onFilterChange={onFilterChange} />
      <DeliveryLogsTable
        key={filterKey}
        onFetchPage={onFetchPage}
        data={data}
        pagination={pagination}
        loading={loading}
      />
    </Stack>
  );
}

DeliveryLogsTab.propTypes = {
  webhookConfigId: PropTypes.string.isRequired,
};
